import React from "react";
import { useLocation, Link } from "react-router-dom";
import { HomePageSlider } from "./HomePageSlider";

export default function RegistrationPending() {
  const location = useLocation();
  const userEmail = location.state?.userEmail;

  return (
    <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
      <div className="bg-overlay" style={{ backgroundColor: "#F2F44E" }}></div>
      <div className="auth-page-content overflow-hidden mt-lg-4">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="card overflow-hidden">
                <div className="row g-0">
                  {/* Left Column - Content */}
                  <div className="col-lg-6">
                    <div className="card overflow-hidden rounded-4 loginbox shadow">
                      <div className="p-lg-5 p-4 text-center">
                        <h3 className="text-center mb-4">
                          REGISTRATION PENDING
                        </h3>
                        <div className="text-warning mb-3">
                          <i
                            className="ri-mail-send-fill"
                            style={{ fontSize: "64px" }}
                          ></i>
                        </div>
                        <p className="mb-3">
                          We've sent a verification link to your email:{" "}
                          <strong>{userEmail || "your email"}</strong>
                        </p>
                        <p className="mb-4">
                          Please check your email and click the verification
                          link to activate your account.
                        </p>
                        <div className="alert alert-info">
                          <small>
                            <strong>Note:</strong> If you don't see the email,
                            check your spam folder.
                          </small>
                        </div>
                        <div className="mt-4">
                          <Link to="/" className="btn btn-primary w-100">
                            Return to Homepage
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  <HomePageSlider />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
